import { createSignal } from "solid-js";

import TextInput from "@repo/ui/inputs/TextInput";

declare namespace PasswordInput {
  type Props = TextInput.Props;
}

function PasswordInput(props: D<PasswordInput.Props>) {
  const [hidePassword, setHidePassword] = createSignal(true);

  return (
    <TextInput
      {...props}
      type={hidePassword() ? "password" : "text"}
      action={
        <TextInput.Action.Visibility
          hidden={hidePassword()}
          onClick={() => setHidePassword(!hidePassword())}
        />
      }
    />
  );
}

export default PasswordInput;
